import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/* ------------------------------------------------------------------ */
/*  ScrollToTop — scrolls to top on forward navigation                 */
/*  Does NOT interfere with browser back-button scroll restoration     */
/*  See PROMPT-F5-012                                                   */
/* ------------------------------------------------------------------ */

export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Only scroll on forward navigation — the browser handles popstate
    // scroll restoration natively via history.scrollRestoration = 'auto'
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

ScrollToTop.displayName = 'ScrollToTop'
